import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OfflineAuthGuard } from './guards/offline-auth.guard';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'transfer-order',
    loadChildren: () => import('./pages/transfer-order/transfer-order.module').then(m => m.TransferOrderPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'warehouse-receipt',
    loadChildren: () => import('./pages/warehouse-receipt/warehouse-receipt.module').then( m => m.WarehouseReceiptPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'put-away',
    loadChildren: () => import('./pages/put-away/put-away/put-away.module').then( m => m.PutAwayPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'inventory-put-away',
    loadChildren: () => import('./pages/put-away/inventory-put-away/inventory-put-away.module').then( m => m.InventoryPutAwayPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'warehouse-shipment',
    loadChildren: () => import('./pages/warehouse-shipment/warehouse-shipment.module').then( m => m.WarehouseShipmentPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'inventory-pick',
    loadChildren: () => import('./pages/inventory-pick/inventory-pick.module').then( m => m.InventoryPickPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'warehouse-pick',
    loadChildren: () => import('./pages/warehouse-pick/warehouse-pick.module').then( m => m.WarehousePickPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'stock-take',
    loadChildren: () => import('./pages/stock-take/stock-take.module').then( m => m.StockTakePageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'bulk-break',
    loadChildren: () => import('./pages/bulk-break/bulk-break.module').then( m => m.BulkBreakPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  },
  {
    path: 'company',
    loadChildren: () => import('./auth/company/company.module').then( m => m.CompanyPageModule),
    canActivate: [OfflineAuthGuard, AuthGuard]
  }






];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
